import { Component, EventEmitter, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomerViewModel } from './customer.service';
import { Country } from '../data/countries';
import { APP_SETTINGS } from '../data/settings-data.provider';
import { Settings } from '../data/models';

@Component({
    selector: 'app-new-customer-form',
    styles: [`
    .custom-select {
      width: 100%;
      padding: 10px;
      font-size: 16px;
      border: 1px solid #ccc;
      border-radius: 4px;
      background-color: #fff;
      cursor: pointer;
    }

    .custom-select:focus {
      outline: none;
      border-color: #66afe9;
      box-shadow: 0 0 5px rgba(102, 175, 233, .6);
    }

    .modal-content {
      max-height: 400px;
      overflow-y: auto;
    }

    .custom-option {
      padding: 10px;
      background-color: #fff;
      cursor: pointer;
      border-bottom: 1px solid #ccc;
    }

    .custom-option.placeholder{
      color: #999;
      width: 100%;
    }

    .custom-option:nth-child(3) {
      border-bottom: 2px solid #000;
    }

    .custom-option:hover {
      background-color: #f5f5f5;
    }

    .custom-option.selected {
      background-color: #e9ecef;
    }

    .form-control[readonly] {
      background-color: #fff;
    }
  `],
    template: `
    <form class="row w-100 p-3 g-3" [formGroup]="customerForm" (submit)="submitForm()">
      <div class="col-12">
        <label for="input-email" class="form-label" i18n>Email</label>
        <input type="email" class="form-control" id="input-email" ngbAutofocus
               formControlName="email"
               [class.is-invalid]="customerForm.controls.email.invalid && (customerForm.controls.email.dirty || customerForm.controls.email.touched)">
        <div class="invalid-feedback" i18n>
          E-Mail ist falsch.
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="check-newsletter" formControlName="addToNewsletter">
          <label class="form-check-label" for="check-newsletter" i18n>Akzeptiert Newsletter?</label>
        </div>
      </div>
      <div class="col-lg-4 col-md-6">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="check-register-customer" formControlName="registerCustomer">
          <label class="form-check-label" for="check-register-customer" i18n>Kunde registrieren?</label>
        </div>
      </div>
      <div class="border-bottom"></div>
      <div class="col-12">
        <h5 i18n>Adresse</h5>
      </div>
      <div class="col-lg-1 col-md-3">
        <label for="input-title" class="form-label" i18n>Anrede</label>
        <select id="input-title" class="form-select" formControlName="title">
          <option selected value="">-</option>
          <option value="Herr" i18n>Herr</option>
          <option value="Frau" i18n>Frau</option>
        </select>
      </div>
      <div class="col-lg-3 col-md-9">
        <label for="input-first-name" class="form-label" i18n>Vorname</label>
        <input type="text" class="form-control" id="input-first-name" formControlName="firstName"
               [class.is-invalid]="customerForm.controls.firstName.invalid && (customerForm.controls.firstName.touched || customerForm.controls.firstName.dirty)">
      </div>
      <div class="col-lg-4 col-md-12">
        <label for="input-last-name" class="form-label" i18n>Nachname</label>
        <input type="text" class="form-control" id="input-last-name" formControlName="lastName"
               [class.is-invalid]="customerForm.controls.lastName.invalid && (customerForm.controls.lastName.touched || customerForm.controls.lastName.dirty)">
      </div>
      <div class="col-lg-4 col-md-6">
        <label for="input-company" class="form-label" i18n>Firma</label>
        <input type="text" class="form-control" id="input-company" formControlName="company">
      </div>
      <div class="col-lg-4 col-md-6">
        <label for="input-tel" class="form-label" i18n>Telefonnummer</label>
        <input type="text" class="form-control" id="input-tel" formControlName="tel">
      </div>
      <div class="col-lg-4 col-md-12">
        <label for="input-street" class="form-label" i18n>Strasse</label>
        <input type="text" class="form-control" id="input-street" formControlName="street">
      </div>
      <div class="col-lg-1 col-md-3">
        <label for="input-house-number" class="form-label" i18n>Hausnr.</label>
        <input type="text" class="form-control" id="input-house-number" formControlName="houseNumber">
      </div>
      <div class="col-lg-3 col-md-9">
        <label for="input-address-supplement" class="form-label" i18n>Adresszusatz</label>
        <input type="text" class="form-control" id="input-address-supplement" formControlName="addressSupplement">
      </div>
      <div class="col-lg-1 col-md-3">
        <label for="input-postcode" class="form-label" i18n>PLZ</label>
        <input type="text" class="form-control" id="input-postcode" formControlName="postcode">
      </div>
      <div class="col-lg-3 col-md-9">
        <label for="input-place" class="form-label" i18n>Ort</label>
        <input type="text" class="form-control" id="input-place" formControlName="place"
               [class.is-invalid]="customerForm.controls.place.invalid && (customerForm.controls.place.touched || customerForm.controls.place.dirty)">
      </div>
      <div class="col-lg-8 col-md-12">
        <label for="input-country" class="form-label" i18n>Land</label>
        <input
          id="input-country"
          class="form-control"
          [class.is-invalid]="customerForm.controls.country.invalid && (customerForm.controls.country.touched || customerForm.controls.country.dirty)"
          formControlName="country"
          [value]="selectedCountry?.country"
          placeholder="Bitte wählen"
          (click)="openModal(modal)"
          readonly
        />
        <ng-template #modal let-modal>
          <div class="modal-header">
            <h5 class="modal-title" i18n>Land auswählen</h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
          </div>
          <div class="modal-body">
            <div
              *ngFor="let country of countries; let i = index"
              class="custom-option"
              [class.selected]="selectedCountry?.alpha2code === country.alpha2code"
              (click)="selectCountry(country, modal)"
            >
              {{ country.country }}
            </div>
          </div>
        </ng-template>
      </div>
      <div class="border-bottom"></div>
      <div class="col-12 d-flex justify-content-end">
        <button type="submit" class="btn btn-info btn-lg">Kunde speichern</button>
      </div>
    </form>
  `,
    standalone: false
})
export class NewCustomerFormComponent implements OnChanges {
  @Output() formSubmitted: EventEmitter<CustomerViewModel> = new EventEmitter<CustomerViewModel>();
  @Input() countries: Country[] = [];
  customerForm: UntypedFormGroup;
  selectedCountry?: Country;

  constructor(private readonly formBuilder: UntypedFormBuilder, private modalService: NgbModal, @Inject(APP_SETTINGS) private settings: Settings) {
    this.customerForm = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required]],
      addToNewsletter: [false, Validators.required],
      registerCustomer: [false, Validators.required],
      title: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      company: [''],
      tel: [''],
      street: [''],
      houseNumber: [''],
      addressSupplement: [''],
      postcode: [''],
      place: ['', Validators.required],
      country: ['', Validators.required], // Initialize as empty
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.countries && this.countries.length > 0) {
      const defaultCountryCode = this.settings.taxRates.taxCountry.countryCode; // Adjust based on your settings structure
      this.selectedCountry = this.countries.find(country => country.alpha2code === defaultCountryCode);

      if (this.selectedCountry) {
        this.customerForm.controls.country.setValue(this.selectedCountry.country);
      }
    }
  }

  openModal(content: any) {
    this.modalService.open(content, { centered: true });
  }

  selectCountry(country: Country, modal: NgbModalRef) {
    this.selectedCountry = country;
    this.customerForm.controls.country.setValue(country.alpha2code);
    modal.close();
  }

  submitForm() {
    if (!this.customerForm.valid) {
      this.customerForm.markAllAsTouched();
      return;
    }

    this.formSubmitted.emit(this.customerForm.value as CustomerViewModel);
  }
}
